import React from 'react';

import styled from 'styled-components';

import Header from '../../components/Header';
import Footer from '../../components/MFooter'

function Page() {
    return (<div>
        <Header/>
        <Home/>
        <Footer/>
    </div>)
}

export default Page;


function Home(){

    return (
        <Simulador>
            <iframe title='Simulador' loading="lazy" className='simulador-plataforma'
                src='https://wokwi.com/arduino/projects/311106072082383424'
            />
        </Simulador>
    )
}

const Simulador = styled.div`
    position: relative;
    width : 90%;
    margin: 0 auto;
    height : 0;
    padding-top : 159.5745%;

    padding-bottom : 48px;
    box-shadow : 0 2px 8px 0 rgba(63, 69, 81, 0.16);
    margin-top : 1.6em;
    margin-bottom : 0.9em;
    overflow: hidden;

    border-radius : 8px;
    will-change: transform;

    .simulador-plataforma {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border: none;
        padding: 0;
        margin: 0;

    }

`;
